<script setup>
import { useUpdate } from '@/composables/useUpdate'

// pages/administration/update/index.vue — Module 23 (§31). Status versi,
// tombol Cek Update, Release Notes. UpdateService backend adalah local
// stub (Update Server/Owner Platform belum ada) — halaman ini tetap
// dibangun sesuai bentuk data yang akan dikembalikan begitu server
// sungguhan ada, lihat CLAUDE.md & ERROR_LOG.md.
definePage({
  meta: {
    layout: 'default',
    action: 'manage',
    subject: 'Update',
  },
})

const { status, checking, checkForUpdate } = useUpdate()

onMounted(checkForUpdate)
</script>

<template>
  <div>
    <h4 class="text-h4 font-weight-bold mb-1">
      Update Aplikasi
    </h4>
    <p class="text-body-2 text-medium-emphasis mb-4">
      Cek versi terbaru dari Update Server (§31)
    </p>

    <VCard class="mb-4">
      <VCardText class="pa-6">
        <VAlert
          v-if="status?.note"
          type="info"
          variant="tonal"
          density="compact"
          class="mb-4"
        >
          {{ status.note }}
        </VAlert>
        <p class="mb-1">
          Versi Saat Ini: <strong>{{ status?.current_version ?? '-' }}</strong>
        </p>
        <p class="text-caption text-medium-emphasis mb-4">
          Terakhir dicek: {{ status?.checked_at ?? '-' }}
        </p>
        <VBtn
          :loading="checking"
          prepend-icon="ri-refresh-line"
          @click="checkForUpdate"
        >
          Cek Update
        </VBtn>
      </VCardText>
    </VCard>

    <UpdateNotesViewer
      :update-available="status?.update_available ?? false"
      :latest-version="status?.latest_version"
      :release-notes="status?.release_notes"
    />
  </div>
</template>
